import { Span } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { PrimaryButton } from '../General/Buttons/PrimaryButton';
import { Screen } from './Screen';


export class MalfunctionScreen extends Screen
{
    constructor(_lang: Translations, reason: string)
    {
        super(
            new Span("❌ " + _lang.Problem).Class("launching-label"),
            "\n" + reason + "\n\n\n",
            new PrimaryButton(_lang.Help)
                .OnClick(() => window.open("https://tutorial.specteam.pl", "_blank"))
        );
    }
}
